import { Text } from "@clipboard-health/ui-components";

import { InsightContentWrapper } from "./Insight/InsightContentWrapper";

export function LoadingInsightsState() {
  return (
    <InsightContentWrapper>
      <Text variant="h1" sx={{ fontSize: "4.75rem", marginTop: 12 }}>
        👀
      </Text>
      <Text variant="h1" sx={{ fontSize: "4.75rem" }}>
        Hold on...
      </Text>

      <Text variant="h5" sx={(theme) => ({ color: theme.palette.text.secondary, paddingTop: 4 })}>
        We&apos;re crunching the numbers to show all the amazing things you&apos;ve done this year.
      </Text>
    </InsightContentWrapper>
  );
}
